export default "__VITE_ASSET__BZ9g3SPN__"